import { CmsContentPage } from '@honeycomb/ui';
import { GetServerSidePropsContext } from 'next';
import { getFacadeContentQuery, GetFacadeContentQuery, getPageAndGlobalProps } from '@honeycomb/data';

export default function Transfers(data: GetFacadeContentQuery): React.JSX.Element {
    const { getPage } = data;
    return <CmsContentPage {...{ getPage }} />;
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
    let pageData;
    // eslint-disable-next-line prefer-const
    pageData = await getPageAndGlobalProps<GetFacadeContentQuery, GetServerSidePropsContext>(
        context,
        getFacadeContentQuery('transfers', [], context.query?.isPreview)
    );
    return pageData;
}
